import { createRouter, createWebHistory } from 'vue-router';

import { registerErrorMiddleware, useErrorStore } from '@ohmybible/core';

import { i18n } from '@/core/i18n';

import { authMiddleware } from '../middlewares/auth';
import NotFoundPage from '../pages/NotFoundPage.vue';

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: (_to, _from, savedPosition) => savedPosition ?? { top: 0 },
  routes: [
    // Catch-all 404 — modules add their routes in front of it.
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: NotFoundPage,
      meta: {
        public: true,
      },
    },
  ],
});

// Snapshot errors first, so a guard below can set a fresh one.
registerErrorMiddleware(router);
router.beforeEach(authMiddleware);

// A deploy replaced the chunks this tab was built against.
router.onError((error: Error) => {
  if (
    error.message.includes('Failed to fetch dynamically imported module')
    || error.message.includes('Importing a module script failed')
  ) {
    const { t } = i18n.global;

    useErrorStore().setError({
      statusCode: 418,
      title: t('errors.updated.title'),
      description: t('errors.updated.description'),
      critical: true,
    });
  }
});

export default router;
